import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.8698 4.28187C10.5773 4.57437 10.5773 5.04687 10.8698 5.33937L13.7798 8.24937H2.40234C1.98984 8.24937 1.65234 8.58687 1.65234 8.99937C1.65234 9.41187 1.98984 9.74937 2.40234 9.74937H13.7873L10.8773 12.6594C10.5848 12.9519 10.5848 13.4244 10.8773 13.7169C11.1698 14.0094 11.6423 14.0094 11.9348 13.7169L16.1273 9.52437C16.4198 9.23187 16.4198 8.75938 16.1273 8.46688L11.9273 4.28187C11.6423 3.98938 11.1623 3.98938 10.8698 4.28187Z",
			fill: "#A0A4BE"
		})
	})
});
export default SvgArrowRight;
